//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.7.0 (NJsonSchema v10.6.7.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { IApplianceDto } from "@/models/applianceVm";
import { UnitArea } from "@/store/regions";
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosResponseHeaders,
  CancelToken,
} from "axios";

export interface IIncrClient {
  /**
   * @param callSign (optional)
   * @param kCode (optional)
   * @param kCodeStatus (optional)
   * @param fleet (optional)
   * @param cadNumber (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getAppliancesList(
    user: string,
    callSign?: string[],
    kCode?: string[],
    kCodeStatus?: string[],
    fleet?: string,
    cadNumber?: string[],
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean
  ): Promise<IApplianceDto[]>;
  /**
   * @return Success
   */
  getCadEvent(user: string, cadNumber: string): Promise<void>;
  /**
   * @param minimumRowId (optional)
   * @param minimumObjectId (optional)
   * @param minimumSystemMessageId (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getCadEvent2(
    dataSet: string,
    user: string,
    cadNumber: string,
    minimumRowId?: number,
    minimumObjectId?: number,
    minimumSystemMessageId?: number,
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean
  ): Promise<void>;
  /**
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  incidentReport(
    user: string,
    cadNumber: string,
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean
  ): Promise<void>;
  /**
   * @param type (optional)
   * @param class (optional)
   * @param responding (optional)
   * @param state (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getCadEventsIndex(
    user: string,
    type?: string[],
    eventClass?: string,
    responding?: boolean,
    state?: string,
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean
  ): Promise<void>;
  /**
   * @param cadNumber (optional)
   * @param callSign (optional)
   * @param locationLevel1 (optional)
   * @param locationLevel2 (optional)
   * @param station (optional)
   * @param zone (optional)
   * @param type (optional)
   * @param class (optional)
   * @param responding (optional)
   * @param state (optional)
   * @param minAssignedUnits (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getCadEventsList(
    user: string,
    cadNumber?: string[],
    callSign?: string[],
    locationLevel1?: string,
    locationLevel2?: string,
    station?: string,
    zone?: string,
    type?: string[],
    eventClass?: string,
    responding?: boolean,
    state?: string,
    minAssignedUnits?: number,
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean
  ): Promise<void>;
  /**
   * @return Success
   */
  putFilterCategories(key: string, body: IncrFilterCategory[]): Promise<void>;
  /**
   * @param level (optional)
   * @param maximumLevel (optional)
   * @return Success
   */
  getUnits(level?: string[], maximumLevel?: number): Promise<UnitArea[]>;
}

export class IncrClient implements IIncrClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  // protected jsonParseReviver?: ((key: string, value: any) => any) =
  //   undefined;
  // TODO figure out the auth part of this. How to inject the auth token into the header???
  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : "https://incrpoc-uat-api-as.azurewebsites.net";
  }

  /**
   * @param callSign (optional)
   * @param kCode (optional)
   * @param kCodeStatus (optional)
   * @param fleet (optional)
   * @param cadNumber (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getAppliancesList(
    user: string,
    callSign?: string[],
    kCode?: string[],
    kCodeStatus?: string[],
    fleet?: string,
    cadNumber?: string[],
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean,
    cancelToken?: CancelToken
  ): Promise<IApplianceDto[]> {
    let url_ = this.baseUrl + "/incr/GetAppliancesList?";
    if (user === undefined || user === null)
      throw new Error(
        "The parameter 'user' must be defined and cannot be null."
      );
    else url_ += "user=" + encodeURIComponent("" + user) + "&";
    if (callSign === null)
      throw new Error("The parameter 'callSign' cannot be null.");
    else if (callSign !== undefined)
      callSign &&
        callSign.forEach((item) => {
          url_ += "CallSign=" + encodeURIComponent("" + item) + "&";
        });
    if (kCode === null)
      throw new Error("The parameter 'kCode' cannot be null.");
    else if (kCode !== undefined)
      kCode &&
        kCode.forEach((item) => {
          url_ += "KCode=" + encodeURIComponent("" + item) + "&";
        });
    if (kCodeStatus === null)
      throw new Error("The parameter 'kCodeStatus' cannot be null.");
    else if (kCodeStatus !== undefined)
      kCodeStatus &&
        kCodeStatus.forEach((item) => {
          url_ += "KCodeStatus=" + encodeURIComponent("" + item) + "&";
        });
    if (fleet === null)
      throw new Error("The parameter 'fleet' cannot be null.");
    else if (fleet !== undefined)
      url_ += "Fleet=" + encodeURIComponent("" + fleet) + "&";
    if (cadNumber === null)
      throw new Error("The parameter 'cadNumber' cannot be null.");
    else if (cadNumber !== undefined)
      cadNumber &&
        cadNumber.forEach((item) => {
          url_ += "CadNumber=" + encodeURIComponent("" + item) + "&";
        });
    if (minutes === null)
      throw new Error("The parameter 'minutes' cannot be null.");
    else if (minutes !== undefined)
      url_ += "Minutes=" + encodeURIComponent("" + minutes) + "&";
    if (hours === null)
      throw new Error("The parameter 'hours' cannot be null.");
    else if (hours !== undefined)
      url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
    if (days === null) throw new Error("The parameter 'days' cannot be null.");
    else if (days !== undefined)
      url_ += "Days=" + encodeURIComponent("" + days) + "&";
    if (begin === null)
      throw new Error("The parameter 'begin' cannot be null.");
    else if (begin !== undefined)
      url_ +=
        "Begin=" + encodeURIComponent(begin ? "" + begin.toJSON() : "") + "&";
    if (end === null) throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
      url_ += "End=" + encodeURIComponent(end ? "" + end.toJSON() : "") + "&";
    if (align === null)
      throw new Error("The parameter 'align' cannot be null.");
    else if (align !== undefined)
      url_ += "Align=" + encodeURIComponent("" + align) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAppliancesList(_response);
      });
  }

  protected processGetAppliancesList(
    response: AxiosResponse
  ): Promise<IApplianceDto[]> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const appliances = response.data.appliancesListResults;
      return Promise.resolve<IApplianceDto[]>(appliances as IApplianceDto[]);
    } else if (status === 204) {
      const appliances = response.data.appliancesListResults;
      return Promise.resolve<IApplianceDto[]>(appliances as IApplianceDto[]);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<IApplianceDto[]>([] as IApplianceDto[]);
  }

  /**
   * @return Success
   */
  getCadEvent(
    user: string,
    cadNumber: string,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/incr/GetCadEvent?";
    if (user === undefined || user === null)
      throw new Error(
        "The parameter 'user' must be defined and cannot be null."
      );
    else url_ += "user=" + encodeURIComponent("" + user) + "&";
    if (cadNumber === undefined || cadNumber === null)
      throw new Error(
        "The parameter 'cadNumber' must be defined and cannot be null."
      );
    else url_ += "CadNumber=" + encodeURIComponent("" + cadNumber) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCadEvent(_response);
      });
  }

  protected processGetCadEvent(response: AxiosResponse): Promise<void> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param minimumRowId (optional)
   * @param minimumObjectId (optional)
   * @param minimumSystemMessageId (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getCadEvent2(
    dataSet: string,
    user: string,
    cadNumber: string,
    minimumRowId: number | undefined,
    minimumObjectId: number | undefined,
    minimumSystemMessageId: number | undefined,
    minutes: number | undefined,
    hours: number | undefined,
    days: number | undefined,
    begin: Date | undefined,
    end: Date | undefined,
    align: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/incr/GetCadEvent/{dataSet}?";
    if (dataSet === undefined || dataSet === null)
      throw new Error("The parameter 'dataSet' must be defined.");
    url_ = url_.replace("{dataSet}", encodeURIComponent("" + dataSet));
    if (user === undefined || user === null)
      throw new Error(
        "The parameter 'user' must be defined and cannot be null."
      );
    else url_ += "user=" + encodeURIComponent("" + user) + "&";
    if (cadNumber === undefined || cadNumber === null)
      throw new Error(
        "The parameter 'cadNumber' must be defined and cannot be null."
      );
    else url_ += "CadNumber=" + encodeURIComponent("" + cadNumber) + "&";
    if (minimumRowId === null)
      throw new Error("The parameter 'minimumRowId' cannot be null.");
    else if (minimumRowId !== undefined)
      url_ += "MinimumRowId=" + encodeURIComponent("" + minimumRowId) + "&";
    if (minimumObjectId === null)
      throw new Error("The parameter 'minimumObjectId' cannot be null.");
    else if (minimumObjectId !== undefined)
      url_ +=
        "MinimumObjectId=" + encodeURIComponent("" + minimumObjectId) + "&";
    if (minimumSystemMessageId === null)
      throw new Error("The parameter 'minimumSystemMessageId' cannot be null.");
    else if (minimumSystemMessageId !== undefined)
      url_ +=
        "MinimumSystemMessageId=" +
        encodeURIComponent("" + minimumSystemMessageId) +
        "&";
    if (minutes === null)
      throw new Error("The parameter 'minutes' cannot be null.");
    else if (minutes !== undefined)
      url_ += "Minutes=" + encodeURIComponent("" + minutes) + "&";
    if (hours === null)
      throw new Error("The parameter 'hours' cannot be null.");
    else if (hours !== undefined)
      url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
    if (days === null) throw new Error("The parameter 'days' cannot be null.");
    else if (days !== undefined)
      url_ += "Days=" + encodeURIComponent("" + days) + "&";
    if (begin === null)
      throw new Error("The parameter 'begin' cannot be null.");
    else if (begin !== undefined)
      url_ +=
        "Begin=" + encodeURIComponent(begin ? "" + begin.toJSON() : "") + "&";
    if (end === null) throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
      url_ += "End=" + encodeURIComponent(end ? "" + end.toJSON() : "") + "&";
    if (align === null)
      throw new Error("The parameter 'align' cannot be null.");
    else if (align !== undefined)
      url_ += "Align=" + encodeURIComponent("" + align) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCadEvent2(_response);
      });
  }

  protected processGetCadEvent2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      const resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Not Found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  incidentReport(
    user: string,
    cadNumber: string,
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/incr/GetCadEvent/IncidentReport?";
    if (user === undefined || user === null)
      throw new Error(
        "The parameter 'user' must be defined and cannot be null."
      );
    else url_ += "user=" + encodeURIComponent("" + user) + "&";
    if (cadNumber === undefined || cadNumber === null)
      throw new Error(
        "The parameter 'cadNumber' must be defined and cannot be null."
      );
    else url_ += "CadNumber=" + encodeURIComponent("" + cadNumber) + "&";
    if (minutes === null)
      throw new Error("The parameter 'minutes' cannot be null.");
    else if (minutes !== undefined)
      url_ += "Minutes=" + encodeURIComponent("" + minutes) + "&";
    if (hours === null)
      throw new Error("The parameter 'hours' cannot be null.");
    else if (hours !== undefined)
      url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
    if (days === null) throw new Error("The parameter 'days' cannot be null.");
    else if (days !== undefined)
      url_ += "Days=" + encodeURIComponent("" + days) + "&";
    if (begin === null)
      throw new Error("The parameter 'begin' cannot be null.");
    else if (begin !== undefined)
      url_ +=
        "Begin=" + encodeURIComponent(begin ? "" + begin.toJSON() : "") + "&";
    if (end === null) throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
      url_ += "End=" + encodeURIComponent(end ? "" + end.toJSON() : "") + "&";
    if (align === null)
      throw new Error("The parameter 'align' cannot be null.");
    else if (align !== undefined)
      url_ += "Align=" + encodeURIComponent("" + align) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processIncidentReport(_response);
      });
  }

  protected processIncidentReport(response: AxiosResponse): Promise<void> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param type (optional)
   * @param class (optional)
   * @param responding (optional)
   * @param state (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getCadEventsIndex(
    user: string,
    type?: string[],
    eventClass?: string,
    responding?: boolean,
    state?: string,
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/incr/GetCadEventsIndex?";
    if (user === undefined || user === null)
      throw new Error(
        "The parameter 'user' must be defined and cannot be null."
      );
    else url_ += "user=" + encodeURIComponent("" + user) + "&";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      type &&
        type.forEach((item) => {
          url_ += "Type=" + encodeURIComponent("" + item) + "&";
        });

    if (eventClass === null)
      throw new Error("The parameter 'class' cannot be null.");
    else if (eventClass !== undefined)
      url_ += "Class=" + encodeURIComponent("" + eventClass) + "&";
    if (responding === null)
      throw new Error("The parameter 'responding' cannot be null.");
    else if (responding !== undefined)
      url_ += "Responding=" + encodeURIComponent("" + responding) + "&";
    if (state === null)
      throw new Error("The parameter 'state' cannot be null.");
    else if (state !== undefined)
      url_ += "State=" + encodeURIComponent("" + state) + "&";
    if (minutes === null)
      throw new Error("The parameter 'minutes' cannot be null.");
    else if (minutes !== undefined)
      url_ += "Minutes=" + encodeURIComponent("" + minutes) + "&";
    if (hours === null)
      throw new Error("The parameter 'hours' cannot be null.");
    else if (hours !== undefined)
      url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
    if (days === null) throw new Error("The parameter 'days' cannot be null.");
    else if (days !== undefined)
      url_ += "Days=" + encodeURIComponent("" + days) + "&";
    if (begin === null)
      throw new Error("The parameter 'begin' cannot be null.");
    else if (begin !== undefined)
      url_ +=
        "Begin=" + encodeURIComponent(begin ? "" + begin.toJSON() : "") + "&";
    if (end === null) throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
      url_ += "End=" + encodeURIComponent(end ? "" + end.toJSON() : "") + "&";
    if (align === null)
      throw new Error("The parameter 'align' cannot be null.");
    else if (align !== undefined)
      url_ += "Align=" + encodeURIComponent("" + align) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCadEventsIndex(_response);
      });
  }

  protected processGetCadEventsIndex(response: AxiosResponse): Promise<void> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param cadNumber (optional)
   * @param callSign (optional)
   * @param locationLevel1 (optional)
   * @param locationLevel2 (optional)
   * @param station (optional)
   * @param zone (optional)
   * @param type (optional)
   * @param class (optional)
   * @param responding (optional)
   * @param state (optional)
   * @param minAssignedUnits (optional)
   * @param minutes (optional)
   * @param hours (optional)
   * @param days (optional)
   * @param begin (optional)
   * @param end (optional)
   * @param align (optional)
   * @return Success
   */
  getCadEventsList(
    user: string,
    cadNumber?: string[],
    callSign?: string[],
    locationLevel1?: string,
    locationLevel2?: string,
    station?: string,
    zone?: string,
    type?: string[],
    eventClass?: string,
    responding?: boolean,
    state?: string,
    minAssignedUnits?: number,
    minutes?: number,
    hours?: number,
    days?: number,
    begin?: Date,
    end?: Date,
    align?: boolean,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/incr/GetCadEventsList?";
    if (user === undefined || user === null)
      throw new Error(
        "The parameter 'user' must be defined and cannot be null."
      );
    else url_ += "user=" + encodeURIComponent("" + user) + "&";
    if (cadNumber === null)
      throw new Error("The parameter 'cadNumber' cannot be null.");
    else if (cadNumber !== undefined)
      cadNumber &&
        cadNumber.forEach((item) => {
          url_ += "CadNumber=" + encodeURIComponent("" + item) + "&";
        });
    if (callSign === null)
      throw new Error("The parameter 'callSign' cannot be null.");
    else if (callSign !== undefined)
      callSign &&
        callSign.forEach((item) => {
          url_ += "CallSign=" + encodeURIComponent("" + item) + "&";
        });
    if (locationLevel1 === null)
      throw new Error("The parameter 'locationLevel1' cannot be null.");
    else if (locationLevel1 !== undefined)
      url_ += "LocationLevel1=" + encodeURIComponent("" + locationLevel1) + "&";
    if (locationLevel2 === null)
      throw new Error("The parameter 'locationLevel2' cannot be null.");
    else if (locationLevel2 !== undefined)
      url_ += "LocationLevel2=" + encodeURIComponent("" + locationLevel2) + "&";
    if (station === null)
      throw new Error("The parameter 'station' cannot be null.");
    else if (station !== undefined)
      url_ += "Station=" + encodeURIComponent("" + station) + "&";
    if (zone === null) throw new Error("The parameter 'zone' cannot be null.");
    else if (zone !== undefined)
      url_ += "Zone=" + encodeURIComponent("" + zone) + "&";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      type &&
        type.forEach((item) => {
          url_ += "Type=" + encodeURIComponent("" + item) + "&";
        });
    if (eventClass === null)
      throw new Error("The parameter 'eventClass' cannot be null.");
    else if (eventClass !== undefined)
      url_ += "Class=" + encodeURIComponent("" + eventClass) + "&";
    if (responding === null)
      throw new Error("The parameter 'responding' cannot be null.");
    else if (responding !== undefined)
      url_ += "Responding=" + encodeURIComponent("" + responding) + "&";
    if (state === null)
      throw new Error("The parameter 'state' cannot be null.");
    else if (state !== undefined)
      url_ += "State=" + encodeURIComponent("" + state) + "&";
    if (minAssignedUnits === null)
      throw new Error("The parameter 'minAssignedUnits' cannot be null.");
    else if (minAssignedUnits !== undefined)
      url_ +=
        "MinAssignedUnits=" + encodeURIComponent("" + minAssignedUnits) + "&";
    if (minutes === null)
      throw new Error("The parameter 'minutes' cannot be null.");
    else if (minutes !== undefined)
      url_ += "Minutes=" + encodeURIComponent("" + minutes) + "&";
    if (hours === null)
      throw new Error("The parameter 'hours' cannot be null.");
    else if (hours !== undefined)
      url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
    if (days === null) throw new Error("The parameter 'days' cannot be null.");
    else if (days !== undefined)
      url_ += "Days=" + encodeURIComponent("" + days) + "&";
    if (begin === null)
      throw new Error("The parameter 'begin' cannot be null.");
    else if (begin !== undefined)
      url_ +=
        "Begin=" + encodeURIComponent(begin ? "" + begin.toJSON() : "") + "&";
    if (end === null) throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
      url_ += "End=" + encodeURIComponent(end ? "" + end.toJSON() : "") + "&";
    if (align === null)
      throw new Error("The parameter 'align' cannot be null.");
    else if (align !== undefined)
      url_ += "Align=" + encodeURIComponent("" + align) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCadEventsList(_response);
      });
  }

  protected processGetCadEventsList(response: AxiosResponse): Promise<void> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  putFilterCategories(
    key: string,
    body: IncrFilterCategory[],
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/incr/OperatingConfiguration/PutFilterCategories?";
    if (key === undefined || key === null)
      throw new Error(
        "The parameter 'key' must be defined and cannot be null."
      );
    else url_ += "key=" + encodeURIComponent("" + key) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    const options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPutFilterCategories(_response);
      });
  }

  protected processPutFilterCategories(response: AxiosResponse): Promise<void> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      const resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException(
        "Unauthorized",
        status,
        _responseText,
        _headers,
        result401
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param level (optional)
   * @param maximumLevel (optional)
   * @return Success
   */
  getUnits(
    level?: string[],
    maximumLevel?: number,
    cancelToken?: CancelToken
  ): Promise<UnitArea[]> {
    let url_ = this.baseUrl + "/ref/OrganisationStructure/GetUnits?";
    if (level === null)
      throw new Error("The parameter 'level' cannot be null.");
    else if (level !== undefined)
      level &&
        level.forEach((item) => {
          url_ += "Level=" + encodeURIComponent("" + item) + "&";
        });
    if (maximumLevel === null)
      throw new Error("The parameter 'maximumLevel' cannot be null.");
    else if (maximumLevel !== undefined)
      url_ += "MaximumLevel=" + encodeURIComponent("" + maximumLevel) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: AxiosError) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUnits(_response);
      });
  }

  protected processGetUnits(response: AxiosResponse): Promise<UnitArea[]> {
    const status = response.status;
    const _headers: AxiosResponseHeaders = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const responseData = response.data.unitResults;
      return Promise.resolve<UnitArea[]>(responseData as UnitArea[]);
    } else if (status === 204) {
      const responseData = response.data.unitResults;
      return Promise.resolve<UnitArea[]>(responseData as UnitArea[]);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: ProblemDetails | null = null;
      const resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("Server Error", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UnitArea[]>([] as UnitArea[]);
  }
}

export class IncrFilterCategory implements IIncrFilterCategory {
  categoryName?: string | undefined;
  isCategorySet?: boolean;
  roleIdentifier?: string;
  sensitiveIndicator?: boolean;
  positionNumber?: number;
  categorySetRoleIdentifier?: string;
  updatedTimestamp?: Date;

  constructor(data?: IIncrFilterCategory) {
    if (data) {
      for (const property in data) {
        if (Object.prototype.hasOwnProperty.call(data, property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.categoryName = _data["categoryName"];
      this.isCategorySet = _data["isCategorySet"];
      this.roleIdentifier = _data["roleIdentifier"];
      this.sensitiveIndicator = _data["sensitiveIndicator"];
      this.positionNumber = _data["positionNumber"];
      this.categorySetRoleIdentifier = _data["categorySetRoleIdentifier"];
      this.updatedTimestamp = _data["updatedTimestamp"]
        ? new Date(_data["updatedTimestamp"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): IncrFilterCategory {
    data = typeof data === "object" ? data : {};
    const result = new IncrFilterCategory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["categoryName"] = this.categoryName;
    data["isCategorySet"] = this.isCategorySet;
    data["roleIdentifier"] = this.roleIdentifier;
    data["sensitiveIndicator"] = this.sensitiveIndicator;
    data["positionNumber"] = this.positionNumber;
    data["categorySetRoleIdentifier"] = this.categorySetRoleIdentifier;
    data["updatedTimestamp"] = this.updatedTimestamp
      ? this.updatedTimestamp.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IIncrFilterCategory {
  categoryName?: string | undefined;
  isCategorySet?: boolean;
  roleIdentifier?: string;
  sensitiveIndicator?: boolean;
  positionNumber?: number;
  categorySetRoleIdentifier?: string;
  updatedTimestamp?: Date;
}

export class ProblemDetails implements IProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (const property in data) {
        if (Object.prototype.hasOwnProperty.call(data, property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    const result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
